// src/services/ReportadasService.js
import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const SeguimientoService = {
    getValidaciones: async ({ token, vid }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/seguimiento/validaciones'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { vid },
            });
            return response.data;
        } catch (error) {
            console.error('Error en SeguimientoService.get:', error);
            throw error;
        }
    },
    createValidaciones: async ({ token, formData }) => {
        try {
            const response = await axios.post(buildApiUrl('/api/seguimiento/validaciones'), formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en SeguimientoService.registrarPostulante:', error);
            throw error;
        }
    },
    disable: async ({ token, formData }) => {
        await axios.put(buildApiUrl('/api/seguimiento/validaciones'), formData, {
            headers: { Authorization: `Bearer ${token}` },
        });
    }
};
